// src/utils/roleUtils.ts
import type { UserRole } from "../types/User";

export const ALL_ROLES: UserRole[] = [
  "Guest",
  "User",
  "Admin",
  "MenuResponsible",
  "Moderator",
  "SuperAdmin",
];

export function getAssignableRoles(currentUserRoles: UserRole[]): UserRole[] {
  const isSuperAdmin = currentUserRoles.includes("SuperAdmin");
  const isAdmin = currentUserRoles.includes("Admin");

  if (isSuperAdmin) {
    // ✅ SuperAdmin sees all
    return ALL_ROLES;
  }

  if (isAdmin) {
    // ✅ Admin sees a limited subset
    return ["Guest", "User", "Admin", "MenuResponsible", "Moderator"];
  }

  // ✅ Everyone else can only assign basic roles
  return ["User"];
}
